module.exports = "<h5><%- modalTitle %> </h5>\n\n<span style=\"white-space: pre-line\"><%= modalBody %></span>";